var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 10.2189H9.13542M1.37117 5.98689C1.14021 6.21837 1.01047 6.53198 1.01042 6.85897V8.59393H2.75621C3.08337 8.59393 3.397 8.46393 3.62829 8.2321L8.77413 3.08356C9.005 2.85205 9.13466 2.53843 9.13466 2.21147C9.13466 1.88452 9.005 1.5709 8.77413 1.33939L8.26604 0.830224C8.15146 0.715581 8.0154 0.624648 7.86565 0.562623C7.7159 0.500599 7.55539 0.4687 7.3933 0.46875C7.23122 0.4688 7.07073 0.500799 6.92102 0.562916C6.7713 0.625034 6.6353 0.716051 6.52079 0.830765L1.37117 5.98689Z",
    stroke: "#262F5F",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.376d7e53b96fa74ec784335c545211a5.svg";
export { ForwardRef as ReactComponent };